




























import { Component, Prop, Vue } from "@/shared/vuepack";
import { EmployerAssociation, PartnerAssociation, Permission } from "@/shared/types";
import { Location } from "vue-router";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import _ from "lodash";
import { useUserStore } from "@/shared/store/user";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

interface Swingable {
  abbr: string;
  id: number;
  key: string;
  name: string;
  isPr: boolean;
}

@Component({
    components: {
        LoginWrapper
    }
})
export default class Swinger extends Vue {
    userStore = useUserStore();
    rolePermissions = useRolePermissionsStore();

    @Prop() routeToEmployerHome: (employerId: number) => Location;
    @Prop() routeToPartnerHome: (partnerId: number) => Location;
    @Prop() routeToPartnerUsers: (partnerId: number) => Location;
    @Prop() routeToPartnerEmployeeSearch: (partnerId: number) => Location;
    @Prop() routeToBulkLiquidation: (partnerId: number) => Location;
    @Prop() routeToLogin: () => Location;

    mounted () {
        if (!this.userStore.loggedIn) {
            this.$router.push(this.routeToLogin());
        }

        const ers = this.userStore.employers || [];
        const prs: any = this.userStore.partnersWithUserRoles || [];

        if (ers.length === 1 && prs.length === 0) {
            this.$router.push(this.routeToEmployerHome(ers[0].employerId));
        }


        if (ers.length === 0 && prs.length === 1) {
            if (this.rolePermissions.userHasPartnerPermission(Permission.PartnerEmployerRead, prs[0].partnerId)) {
                this.$router.push(this.routeToPartnerHome(prs[0].partnerId));
            } else if (this.rolePermissions.userHasPartnerPermission(Permission.ManagePartnerUserRead, prs[0].partnerId)) {
                this.$router.push(this.routeToPartnerUsers(prs[0].partnerId));
            } else if (this.rolePermissions.userHasPartnerPermission(Permission.BulkLiquidationFileUpload, prs[0].partnerId)) {
              this.$router.push(this.routeToBulkLiquidation(prs[0].partnerId));
            } else {
                this.$router.push(this.routeToPartnerEmployeeSearch(prs[0].partnerId));
            }
        }

        if (ers.length === 0 && prs.length === 0) {
            this.userStore.logout();
        }
    }

    swingableLink (swingable: Swingable): Location {
        if (swingable.isPr) {
            if (this.rolePermissions.userHasPartnerPermission(Permission.PartnerEmployerRead, swingable.id)) {
                return this.routeToPartnerHome(swingable.id);
            } else if (this.rolePermissions.userHasPartnerPermission(Permission.ManagePartnerUserRead, swingable.id)) {
                return this.routeToPartnerUsers(swingable.id);
            } else if (this.rolePermissions.userHasPartnerPermission(Permission.BulkLiquidationFileUpload, swingable.id)) {
              return this.routeToBulkLiquidation(swingable.id);
            } else {
                return this.routeToPartnerEmployeeSearch(swingable.id);
            }
        }

        return this.routeToEmployerHome(swingable.id);
    }

    get switchOptions (): Swingable[] {
        let ers = this.userStore.employers;
        if (!ers) {
            ers = [];
        }

        let prs: any = this.userStore.partnersWithUserRoles;
        if (!prs) {
            prs = [];
        }

        const results: Swingable[] = [];
        for (const er of ers) {
            results.push({
                abbr: "",
                id: er.employerId,
                key: "",
                name: er.employerName,
                isPr: false
            });
        }

        for (const pr of prs) {
            results.push({
                abbr: "",
                id: pr.partnerId,
                key: "",
                name: pr.companyName,
                isPr: true
            });
        }

        results.sort((a, b) => a.name.localeCompare(b.name));

        for (const result of results) {
            let abbr = "";
            const pieces = result.name.split(/\W/);

            for (const piece of pieces) {
                if (!piece) {
                continue;
                }

                if (abbr.length >= 2) {
                break;
                }

                abbr += piece[0];
            }

            result.abbr = abbr.toLocaleUpperCase();
            result.key = `${result.isPr}-${result.id}-${result.name}`;
        }

        return _.uniqBy(results, item => item.key);
    }
}
